const FOUNDERS_IMG = "https://customer-assets-lxgj4vgw.emergentagent.net/job_elevated-collective/artifacts/y9oy3rw2_IMG_8562.webp";
const LIFESTYLE_IMG = "https://images.unsplash.com/photo-1747242653891-34b222d4d61d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwZGlubmVyJTIwcGFydHklMjBibGFjayUyMHdvbWVufGVufDB8fHx8MTc4NTY4Njg4OXww&ixlib=rb-4.1.0&q=85";
import TeaserSlot from "@/components/TeaserSlot";

export default function About() {
    return (
        <main data-testid="about-page" className="pt-32 pb-32">
            {/* HERO */}
            <section className="mx-auto max-w-[1600px] px-6 lg:px-12 grid lg:grid-cols-12 gap-16 items-start">
                <div className="lg:col-span-7">
                    <p className="eyebrow">About</p>
                    <h1 className="font-display text-6xl md:text-8xl mt-4 leading-[0.95]">A house for the <em className="text-[color:var(--gold)]">rest of us</em>.</h1>
                    <p className="mt-10 font-serif text-2xl md:text-3xl leading-relaxed max-w-2xl">Mrs.Black(In)Love exists to build rooms — and a community — where love, respect, and belonging are the only requirements for entry.</p>
                    <div className="mt-12 space-y-6 text-[color:var(--cream-muted)] max-w-2xl">
                        <p><em>About the name.</em> Mrs.Black(In)Love is a play on our family's surname — Black. It's a love letter, not a label. Everyone is welcome here.</p>
                        <p>We began with a single long-table dinner. Twelve women. A private home. A rule: no small talk before dessert.</p>
                        <p>What followed was undeniable. We saw what happens when a community with taste, story, and time in common gathers under warm light — with no agenda beyond being fully arrived.</p>
                        <p>Today, Mrs.Black(In)Love is a lifestyle platform: an evolving calendar of curated experiences, an original reality series, a growing library of community storytelling, and a partner house for the brands that get it.</p>
                    </div>
                </div>
                <div className="lg:col-span-5">
                    <img src={LIFESTYLE_IMG} alt="" className="w-full h-[720px] object-cover" />
                </div>
            </section>

            {/* MEET THE FOUNDERS */}
            <section className="mt-40 pt-24 border-t border-[color:var(--espresso)]" data-testid="founders-section">
                <div className="mx-auto max-w-[1600px] px-6 lg:px-12 grid lg:grid-cols-12 gap-16 items-start">
                    <div className="lg:col-span-6">
                        <div className="zoom-parent overflow-hidden">
                            <img src={FOUNDERS_IMG} alt="The founders of Mrs.Black(In)Love" className="w-full h-auto object-cover" data-testid="founders-photo" />
                        </div>
                        <p className="mt-6 text-xs uppercase tracking-[0.24em] text-[color:var(--cream-muted)]">The founders · Mr. &amp; Mrs. Black</p>
                    </div>
                    <div className="lg:col-span-6 lg:pt-8">
                        <p className="eyebrow">Meet the Founders</p>
                        <h2 className="font-display text-5xl md:text-7xl mt-4 leading-[0.95]">Our name tells our story. Our community is <em className="text-[color:var(--gold)]">for everyone</em>.</h2>

                        <div className="mt-12 space-y-6 max-w-xl">
                            <p className="font-serif text-2xl leading-relaxed text-[color:var(--soft-cream)]">
                                Mrs.Black(In)Love was born from our last name, but it was never meant to define who belongs here.
                            </p>
                            <p className="text-[color:var(--cream-muted)] leading-relaxed">
                                As a playful nod to our family name, Black, the name Mrs.Black(In)Love reflects our story while celebrating something much bigger: a community built on connection, joy, and authentic belonging. Whether you're Black, White, Latino, Asian, Indigenous, or from any background — if you value love, respect, and meaningful community, you have a place here.
                            </p>
                            <p className="text-[color:var(--cream-muted)] leading-relaxed">
                                Together, we've made it our mission to create experiences where people can show up fully as themselves, build genuine friendships, celebrate life's moments, and feel seen. What began as a vision to bring people together has grown into a movement centered around one simple belief:
                            </p>
                            <p className="font-display text-4xl md:text-5xl text-[color:var(--gold)] leading-[1.05] pt-2">
                                Community is the new luxury.
                            </p>
                            <p className="text-[color:var(--cream-muted)] leading-relaxed pt-2">
                                Welcome to Mrs.Black(In)Love, where our name tells our story — but our community is for everyone.
                            </p>
                            <p className="pt-6 font-serif italic text-lg text-[color:var(--soft-cream)]">— With love, the Blacks</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* VALUES */}
            <section className="mt-40 py-32 border-t border-[color:var(--espresso)] bg-[color:var(--dark-grey)]">
                <div className="mx-auto max-w-[1600px] px-6 lg:px-12">
                    <p className="eyebrow">Values</p>
                    <div className="mt-10 grid md:grid-cols-3 gap-10">
                        {[
                            { t: "Warmth over noise", d: "We choose rooms, tones, and words that make people feel arrived." },
                            { t: "Sophistication with soul", d: "Elevated does not have to mean cold. We hold both." },
                            { t: "The long view", d: "We are building for the next chapter, the tenth city, the next generation." },
                        ].map((v) => (
                            <div key={v.t}>
                                <h3 className="font-serif text-3xl">{v.t}</h3>
                                <p className="mt-3 text-[color:var(--cream-muted)]">{v.d}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <TeaserSlot
                source="about-slot"
                eyebrow="Original Series · First look"
                title="A cinematic first look."
                subtitle="The debut of the original series is coming together. Here's the trailer we filmed to introduce it."
                cta="Watch on the series page"
            />
        </main>
    );
}
